import { FeatureRoute } from '../billing/FeatureAccess';
import { BillingAccessBoundary } from '../billing/BillingAccess';
import React, { Suspense, lazy } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Profile from "../pages/Profile";
import ForgotPassword from "../pages/ForgotPassword";
import ResetPassword from "../pages/ResetPassword";
import EmailSent from "../pages/EmailSent";
import ChangedPassword from "../pages/ChangedPassword";
import OtpVerification from "../pages/Signup/OtpVerification";
import JoinWorkspace from "../pages/Signup/JoinWorkspace";
import CreateWorkspace from "../pages/Signup/CreateWorkspace";
import CreatePassword from "../pages/Signup/CreatePassword";
import TermsOfService from "../pages/Signup/TermsOfService";
import PasswordCreated from "../pages/Signup/PasswordCreated";
import AppLayout from "../components/AppLayout";
import Settings from "../pages/Settings";
import DashboardComponent from "../components/Dashboard";
import Clients from "../pages/Clients";
import Marketing from "../pages/Marketing";
import NotificationCampaign from "../pages/Marketing/NotificationCampaign";
import Referrals from "../pages/Referrals";
import Overview from "../pages/Clients/Overview";
import CircularProgressLoading from "../common/CircularProgress";
import { useSelector } from "react-redux";
import CaseOverview from "../pages/Cases/CaseOverview";
import CreateAgentName from "../pages/Signup/CreateAgentName";
import { getMyValue } from "../utils/helpers";
import ProtectedRoute from "../ProtectedRoute";
import LoadingSpinner from "../components/LoadingSpinner";
import CrashScreen from "../components/CrashScreen.js";
import Integrations from "../pages/Integrations/index.js";
import IntegrationSuccessPage from "../components/IntegrationSuccessPage/index.js";
import CaseSummaryPdfPage from "../pages/CaseSummaryPdfPage/index.js";
import BillingSetup from '../billing/BillingSetup';
import BillingPayment from '../billing/BillingPayment';

// import Layout from '../Layout';
// import Protected from './protected';
// import Loader from '../common/Loader';
// import UnProtected from './unProtected';

const Signup = lazy(() => import("../pages/Signup"));
const Signin = lazy(() => import("../pages/Signin"));
const Cases = lazy(() => import("../pages/Cases"));

const MainRouts = () => {
  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;
  // The store already initializes these values from cookies. Deferring them to
  // an effect redirects fresh report tabs to sign-in before that effect runs.
  const isAuthenticated =
    getMyValue(userInfo?.token) && getMyValue(userInfo?.agentId) && getMyValue(userInfo?.agencyId);

  // console.log("CCCCC", token && agentId && agencyId);

  // const [userInfo, setUserInfo] = useState({
  //   token: "",
  //   agencyId: "",
  //   agentId: "",
  // });

  // useEffect(() => {
  //   const token = Cookies.get("token");
  //   const agentId = Cookies.get("agentId");
  //   const agencyId = Cookies.get("agencyId");

  //   if (
  //     token !== userInfo.token ||
  //     agencyId !== userInfo.agencyId ||
  //     agentId !== userInfo.agentId
  //   ) {
  //     setUserInfo({
  //       token: token || "",
  //       agencyId: agencyId || "",
  //       agentId: agentId || "",
  //     });
  //   }
  // }, []);

  // console.log("USERINFO", userInfo);

  return (
    <BrowserRouter>
      <Suspense fallback={<CircularProgressLoading />}>
        <Routes>
          <Route element={<ProtectedRoute isAuthenticated={isAuthenticated} />}>
            {/* <Route
            element={
              userInfo?.token ? <AppLayout /> : <Navigate to="/signin" />
            }
          > */}

            {/* <ProtectedRoute
            path="/"
            component={<DashboardComponent />}
            isAuthenticated={isAuthenticated}
          /> */}

            {/* <Route exact path="/" element={<DashboardComponent />} /> */}
            <Route
              exact
              path="/"
              element={
                isAuthenticated ? (
                  <DashboardComponent />
                ) : (
                  <Navigate to="/signin" />
                )
              }
            />
            {/* <Route exact path="/">
              {isAuthenticated ? (
                <DashboardComponent />
              ) : (
                <Navigate to="/signin" />
              )}
            </Route> */}
            <Route
              exact
              path="/cases"
              element={
                <Suspense fallback={<LoadingSpinner />}>
                  <Cases />
                </Suspense>
              }
            />
            <Route exact path="/case/:id" element={<CaseOverview />} />
            <Route exact path="/clients" element={<Clients />} />
            <Route exact path="/client/:id" element={<Overview />} />
            <Route exact path="/marketing" element={<FeatureRoute name="marketing"><Marketing /></FeatureRoute>} />
            <Route path="/marketing/push-notifications/:id" element={<FeatureRoute name="marketing"><NotificationCampaign /></FeatureRoute>} />
            <Route exact path="/referrals" element={<FeatureRoute name="referrals"><Referrals /></FeatureRoute>} />
            <Route exact path="/integrations" element={<Integrations />} />
            <Route exact path="/settings" element={<Settings />} />
            <Route exact path="/profile" element={<Profile />} />
          </Route>

          <Route
            path="/integration-success"
            element={<IntegrationSuccessPage />}
          />
          <Route
            exact
            path="/client-summary-report/:id"
            element={isAuthenticated ? <BillingAccessBoundary><CaseSummaryPdfPage /></BillingAccessBoundary> : <Navigate to="/signin" replace />}
          />
          <Route
            path="/signin"
            element={
              isAuthenticated ? (
                <Navigate to="/" />
              ) : (
                <Suspense fallback={<LoadingSpinner />}>
                  <Signin />
                </Suspense>
              )
            }
          />
          <Route
            path="/forgot-password"
            element={isAuthenticated ? <Navigate to="/" /> : <ForgotPassword />}
          />
          {/* <Route path="/checkmail" element={<EmailSent />} /> */}
          <Route path="/password-changed" element={<ChangedPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route
            path="/register"
            element={
              isAuthenticated ? (
                <Navigate to="/" />
              ) : (
                <Suspense fallback={<LoadingSpinner />}>
                  <Signup />
                </Suspense>
              )
            }
          />
          <Route path="/create-password" element={<CreatePassword />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route path="/pilot-invitation" element={<Navigate to="/billing-setup" replace />} />
          <Route path="/billing-setup" element={<BillingSetup />} />
          <Route path="/billing-payment" element={<BillingPayment />} />
          <Route path="/choose-plan" element={<BillingSetup expired />} />
          <Route path="/otp-verification" element={<OtpVerification />} />
          {/* <Route path="/join-workspace" element={<JoinWorkspace />} /> */}
          <Route path="/create-workspace" element={<CreateWorkspace />} />
          <Route path="/create-agentname" element={<CreateAgentName />} />
          <Route path="/password-created" element={<PasswordCreated />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
};
export default MainRouts;
